import * as React from 'react';
import { connect } from "react-redux";
import { getQueryParam } from "../../../utils/HelperFunctions";
import axios from 'axios';
import { ROOT_URL, SP_HOST_URL } from '../../../actions/constants';
import { CALENDAR_MAX, CALENDAR_MIN } from "../../../utils/DateUtils";
import { Calendar, momentLocalizer } from 'react-big-calendar'
import * as moment from "moment";
import { ScheduleElement } from '../../../models/ScheduleElement';
import StyleUtils from '../../../utils/StyleUtils';
import * as _ from "lodash";
import { Checkbox, PrimaryButton, Spinner, SpinnerSize } from 'office-ui-fabric-react';
import { getScheduleElements, getUkeplanElements } from '../../../actions/Action_Student';
import UkeplanPrintStudent from '../../ukeplan/UkeplanPrintStudent';
moment.locale("nb");

export interface IUkeplanPrintViewStudentProps {
    scheduleElements: any;
    ukeplanelementsstudent:any;
    student: any;
    getScheduleElements(student: any, week: number, year: number);
    getUkeplanElements(statedata: any,week: number,year: number);
  }

  export interface IUkeplanPrintViewStudentState {
    isLoading:boolean;
    week: string;
    year: string;
    selectedDate:any;
    includeSchedule:boolean;
  }



  class UkeplanPrintStudentView extends React.Component<
    IUkeplanPrintViewStudentProps,
    IUkeplanPrintViewStudentState
  > {
    constructor(props) {
        super(props);
      }

    mergeObjectsByPropertyWithReduce(arr: any[], property: string): any[] {
        const mergedObjects = arr.reduce((acc, item) => {
          const key = item[property];
          if (!acc[key]) {
            acc[key] = { ...item };
          } else {
            acc[key] = { ...acc[key], ...item };
          }
          return acc;
        }, {} as { [key: string]: any });
      
        return Object.values(mergedObjects);
      }

    mergeCoursesByPropertyWithReduce(arr: any[], property: string): any[] {
        const mergedObjects = arr.reduce((acc, item) => {
          const key = item[property];
          if (!acc[key]) {
            acc[key] = { ...item };
          } else {
            // Merge News, StudentTasks, StudentTexts
            const n = acc[key].News && item.News ? [...acc[key].News,...item.News] : item.News ? item.News : acc[key].News ? acc[key].News : [];
            const ta = [...acc[key].StudentTasks, ...item.StudentTasks];
            const te = [...acc[key].StudentTexts, ...item.StudentTexts];
            acc[key] = { ...acc[key], News:this.mergeObjectsByPropertyWithReduce(n,"Id"), StudentTasks:this.mergeObjectsByPropertyWithReduce(ta,"WsTaskId"), StudentTexts:this.mergeObjectsByPropertyWithReduce(te,"Id") };
            //acc[key] = { ...acc[key], ...item};
          }
          return acc;
        }, {} as { [key: string]: any});
      
        return Object.values(mergedObjects);
      }

    componentDidMount() {
      // Get queryparams
      const week = getQueryParam("week");
      const year = getQueryParam("year");
      const includeSchedule = true;

      this.props.getScheduleElements(this.props.student, Number(week),Number(year));
      if (this.props.student) {
        this.props.getUkeplanElements({LoginName:this.props.student.LoginName},Number(week),Number(year));
      }
      
      this.setState(
        {
          week:week,
          year:year,
          selectedDate: moment(new Date()).year(Number(year)).week(Number(week)).day(1).toDate(),
          includeSchedule: includeSchedule
        });
    }

    filterEvents() {
        // Returns an empty array if there are ScheduleElements yet
        if (_.isEmpty(this.props.scheduleElements)) {
          return [];
        }
    
        let values = _.values(this.props.scheduleElements).sort((a, b) => {
          if(a.Title < b.Title) { return -1; }
          if(a.Title > b.Title) { return 1; }
          return 0;
        });
    
        return values;
      }

    renderCustomEvent = (scheduleElement: ScheduleElement) => {
        return (
            <div className="custom-event-container">
                <div className="custom-event-label-print">
                    <span className="custom-event-label-time">
                    {scheduleElement.Start ? moment(scheduleElement.Start).format("HH:mm") : ""} - {scheduleElement.End ? moment(scheduleElement.End).format("HH:mm") : ""}
                    </span>
                </div>
                <div style={{color: 'black', wordWrap: "break-word", wordBreak: "break-word"}}>{scheduleElement.Title}</div>
            </div>
        )
      }
    
     eventStyleGetter(se: ScheduleElement) {
        return { style: new StyleUtils().getCalendarScheduleStylePrint() };
      }
      
    render() {
        const localizer = momentLocalizer(moment);

        return (!!this.state && this.props.scheduleElements && this.props.student) ? (
            <div style={{backgroundColor:"#ffffff", padding:"10px"}}>
                <div id="printOutput">
                  <div className="printButton">
                    <div  style={{marginTop:"10px", marginBottom:"10px", display: "flex", alignItems: "center"}}>
                          <PrimaryButton iconProps={{iconName:"Print"}} text='Skriv ut' onClick={()=>window.print()}/>
                          <Checkbox
                            label={`Inkluder timeplan`}
                            checked={this.state.includeSchedule}
                            onChange={(ev, checked) => this.setState({includeSchedule: checked})}
                          />
                    </div>
                  </div>
                    <UkeplanPrintStudent
                        scheduleElements={this.props.scheduleElements}
                        student={this.props.student}
                        ukeplanelementsstudent={this.props.ukeplanelementsstudent}
                        selectedDate={this.state.selectedDate}
                        week={this.state.week}
                        year={this.state.year}
                        includeSchedule={this.state.includeSchedule}
                    />
                </div>
            </div>
      ) : (
        <>
            <Spinner size={SpinnerSize.large}>Vennligst vent...</Spinner>
        </>
      )
    }
  }

  const mapStateToProps = (state) => {
    let ukeplanElements = [];
    if (state.ukeplanelements.AllTAs && state.ukeplanelements.AllTAs.All) {
        ukeplanElements = Object.values(state.ukeplanelements.AllTAs.All)
    }


    return {
        student: state.StudentReducer.student,
        scheduleElements: state.StudentReducer.scheduleElements,
        ukeplanelementsstudent: ukeplanElements,
    };
  };

  export default connect(mapStateToProps,{getScheduleElements, getUkeplanElements})(UkeplanPrintStudentView);